import React, { FC } from 'react';

import * as S from './styles/productDetailsStyles';

interface ProductDetails {
  image: { fluid: { src: string } };
  title: string;
  price: string;
  slug: string;
}

const ProductDetails: FC<ProductDetails> = ({
  image,
  title,
  price,
  slug,
}: ProductDetails) => {
  return (
    <S.Container to={`/products/${slug}`}>
      <S.ProductImage src={image.fluid.src} alt={title} />
      <S.ProductTitle>{title}</S.ProductTitle>
      <S.ProductPrice>${parseInt(price)}</S.ProductPrice>
    </S.Container>
  );
};

export default ProductDetails;
